export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";